import './App.css'
import './styles/pageLayout.css'
import { useEffect, useState } from 'react'
import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import Sidenavbar from './Component/Sidenavbar'
import AddStudent from './Component/AddStudent'
// import TeacherStudent from './Component/TeacherStudent'
import ViewExam from './Component/ViewExam.js'
import AddCourse from './Component/AddCourse'
import AddClass from './Component/AddClass'
import ClassList from './Component/ClassList'
import TakeAttendance from './Component/TakeAttendance'
import TakeTeacherAttendance from './Component/TakeTeacherAttendance'
import Practicenavbar from './Component/Practicenavbar'
import LoginSignup from './Component/LoginSignup'
import RegistrationWizard from './Component/RegistrationWizard'
import StudentProfile from './Component/StudentProfile'
import StudentHomework from './Component/StudentHomework'
import TakeFees from './Component/TakeFees'
import CourseFees from './Component/CourseFees'
import IDcard from './Component/IDcard'
import StudentPromotion from './Component/StudentPromotion'
import EnquiryForm from './Component/EnquiryForm'
import ExamMarksheetView from './Component/ExamMarksheetView'
import TeacherList from './Component/TeacherList'
import FeeStructure from './Component/FeeStructure'
import ApplyFees from './Component/ApplyFees'
import Dashboard from './Component/Dashboard'
import { Toaster } from 'react-hot-toast'
import AddInstitute from './Component/AddInstitute'
import AddNewInstitute from './Component/AddNewInstitute'
import AddSubject from './Component/AddSubject'
import ExamSheet from './Component/ExamSheet'
import AddExamForCourse from './Component/AddExamForCourse'
import ExamSheetAdmitcard from './Component/ExamSheetAdmitcard'
import ExamSheetBulkAdmitcard from './Component/ExamSheetBulkAdmitcard'
import ExamSubjectSchedule from './Component/ExamSubjectSchedule'
import AddExamResult from './Component/AddExamResult'
import AssignClass from './Component/AssignClass'
import ManageStudentFees from './Component/ManageStudentFees'
import FeeChangeLogs from './Component/FeeChangeLogs'
import FeeUpdateLogs from './Component/FeeUpdateLogs'
import CertificateView from './Component/CertificateView'
import GenerateTC from './Component/GenerateTC'
import TransferCertificateList from './Component/TransferCertificateList'
import TransferCertificateView from './Component/TransferCertificateView'
import TemplateBasedCertificate from './Component/TemplateBasedCertificate'
import CertificateTemplate1 from './certificateTemplates/CertificateTemplate1'
import CertificateTemplate2 from './certificateTemplates/CertificateTemplate2'
import CertificateTemplate3 from './certificateTemplates/CertificateTemplate3'
import CertificateTemplate4 from './certificateTemplates/CertificateTemplate4'
import CertificateTemplate5 from './certificateTemplates/CertificateTemplate5'
import CertificateTemplate6 from './certificateTemplates/CertificateTemplate6'
import CertificateTemplate7 from './certificateTemplates/CertificateTemplate7'
import CertificateTemplate8 from './certificateTemplates/CertificateTemplate8'
import FeeRecipt from './Component/FeeRecipt'
import ViewAttendance from './Component/ViewAttendance'
import ViewTeacherAttendance from './Component/ViewTeacherAttendance'
import MyTeacherAttendance from './Component/MyTeacherAttendance'
import TakeLeave from './Component/TakeLeave'
import ViewLeave from './Component/ViewLeave'
import { useAuth } from './Component/AuthContext'
import { SidebarProvider } from './Component/SidebarContext'
import TeacherProfile from './Component/TeacherProfile'
import UserProfile from './Component/UserProfile'
import UserIdCard from './Component/UserIdCard'
import TeacherIdcard from './Component/TeacherIdCard'
import FeeCollection from './Component/FeeCollection'
import PendingFee from './Component/PendingFee'
import Marketer from './Component/Marketer'
import EnrolledCourses from './Component/EnrolledCourses'
import Setting from './Component/Settings'
import UpdateStudentProfile from './Component/UpdateStudentProfile'
import EditTeacherModal from './Component/EditTeacherModal'
import DischargedStudent from './Component/DischargedStudent'
import UpdateStudentEnquiry from './Component/UpdateStudentEnquiry.js'
import StudentFees from './Component/StudentFees.js'
// import ForgotPassword from './Component/ForgotPassword.js'
import ChangePassword from './Component/ChangePassword.js'
import VivekanandCertificate from './Component/VivekanandCertificate.js'
import DischargedStudentFees from './Component/DischargedStudentFees.js'
import LeftTeachers from './Component/LeftTeachers.js'
import StudentTC from './Component/StudentTC.js'
import ParentStudentProfile from './Component/ParentStudentProfile.js'
import RaiseQuery from './Component/RaiseQuery.js'
import ParentStudentList from './Component/ParentStudentList.js'
import ParentDashboard from './Component/ParentDashboard.js'
import ParentStudentFees from './Component/ParentStudentFees.js'
import ParentHomework from './Component/ParentHomework.js'
import ParentHolidays from './Component/ParentHolidays.js'
import ParentViewAttendance from './Component/ParrentViewAttendance.js'
import ParentRegistration from './Component/ParentRegisteration.js'
import GuardianTable from './Component/AddGuardian.js'
import ViewAssignedStudents from './Component/ViewAssignedStudents.js'
import AssignStudentsToGuardian from './Component/AssignStudentsToGuardian.js'
import TeacherStudent from './Component/TeacherStudent.js'
import AddUser from './Component/AddUser.js'
import AssignUserRole from './Component/UserRole.js'
import GuardianChangePwd from './Component/GuardianChangePwd.js'
import DischargedStudentsProfile from './Component/DischargedStdProfile.js'
import DischargedStdAttendance from './Component/DischargedStdAttendance.js'
import PassedOutStudent from './Component/PassedOutStudent.js'
import AddNewStudent from './Component/AddNewStudent.js'
import AddNewEnquiry from './Component/AddNewEnquiry.js'
import AddNewTeacher from './Component/AddNewTeacher.js'
import CreateNotification from './Component/CreateNotification'
import CreateAnnouncement from './Component/CreateAnnouncement'
import NotificationForm from './Component/NotificationForm'
import AnnouncementForm from './Component/AnnouncementForm'
import ViewAnnouncement from './Component/ViewAnnouncement'
import TopAnnouncements from './Component/TopAnnouncements'
import Homework from './Component/Homework'
import HomeworkForm from './Component/HomeworkForm'
import ManageBus from './Component/ManageBus'
import TrackVehicle from './Component/TrackVehicle'
import AttendantPortal from './Component/AttendantPortal'
import CreateBus from './Component/CreateBus'
import AssignBustoStudent from './Component/AssignBustoStudent'
import ViewBusAssignedStd from './Component/ViewBusAssignedStd'
import TemplateAssignment from './Component/TemplateAssignment'
import VehicleTrackPage from './Component/trackVehicle/VehicleTrackPage'
import {
  hasValidInstituteIdCookie,
  setDefaultInvalidInstituteIdCookie,
} from './utils/instituteIdCookie'
import { BUS_ATTENDANT_HOME_ROUTE, isBusAttendantUser } from './utils/busAttendant'
import ManageInstitute from './Component/ManageInstitute.js'
import ViewBusAssignedStudent from './Component/ViewBusAssignedStudent.js'
import AssigningBustoStd from'./Component/AssigningBustoStd.js'
import AssignTemplateCertificate from './Component/AssignTemplateCertificate.js'
import AdmitCard from './Component/AdmitCard.js'
import StudentCertificates from './Component/StudentCertificates.js'
import StudentCertificateView from './Component/StudentCertificateView.js'
import StudentMarksheets from './Component/StudentMarksheets.js'
import StudentMarksheetView from './Component/StudentMarksheetView.js'
import StudentTransferCertificate from './Component/StudentTransferCertificate.js'
import StudentTransferCertificateView from './Component/StudentTransferCertificateView.js'
import BusAllocation from './Component/BusAllocation.js'
import ManageHolidays from './Component/ManageHolidays.js'
import CreateHoliday from './Component/CreateHoliday.js'
import ManageTemplates from './Component/ManageTemplates.js'
import EditTemplate from './Component/EditTemplate.js'
import Notification from './Component/Notification.js'

import MyQueries from './Component/MyQueries.js'
import AdminParentQueryList from './Component/AdminParentQueryList.js'
import AdminSubscription from './Component/AdminSubscription.js'
import AdminSubscriptionPlans from './Component/AdminSubscriptionPlans.js'
import SubscriptionPlanGuard from './Component/SubscriptionPlanGuard.js'
import ParentTopAnnouncements from './Component/ParentTopAnnouncements.js'

const PARENT_HOME_ROUTE = '/parent/dashboard'

/** Redirect old admit-card URL shapes to /student/:studentId/admit-card */
const LegacyAdmitCardRedirect = () => {
  const { studentId, examId } = useParams()
  if (examId) {
    return <Navigate to={`/student/${studentId}/admit-card/${examId}`} replace />
  }
  return <Navigate to={`/student/${studentId}/admit-card`} replace />
}

const isParentUser = (user) => {
  const userType = String(user?.user_type || '').toLowerCase()
  return userType === 'parents' || userType === 'parent'
}

/** Parents/guardians use ParentTopAnnouncements; others use TopAnnouncements */
const TopAnnouncementsEntry = () => {
  try {
    const raw = Cookies.get('user')
    if (raw && isParentUser(JSON.parse(raw))) {
      return <Navigate to="/parent/top-announcements" replace />
    }
  } catch {
    /* ignore */
  }
  return <TopAnnouncements />
}

// Protected Dashboard Component
const ProtectedDashboard = () => {
  const instituteConfirmed = sessionStorage.getItem('institute_confirmed')

  let isAdminUser = false
  try {
    const raw = Cookies.get('user')
    if (raw) {
      const parsed = JSON.parse(raw)
      isAdminUser = parsed?.user_type === 'admin'
      if (isParentUser(parsed)) {
        return <Navigate to={PARENT_HOME_ROUTE} replace />
      }
      if (isBusAttendantUser(parsed)) {
        return <Navigate to={BUS_ATTENDANT_HOME_ROUTE} replace />
      }
    }
  } catch {
    /* ignore */
  }
  
  // Stale-cookie guard applies only to admin (non-admins never set institute_confirmed at login)
  if (hasValidInstituteIdCookie() && !instituteConfirmed && isAdminUser) {
    console.log('⚠️ Stale institute_id cookie detected in ProtectedDashboard. Clearing and redirecting.')
    Cookies.remove('institute_id')
    Cookies.remove('institute_name')
    sessionStorage.removeItem('institute_confirmed')
    sessionStorage.removeItem('institute_confirmed_timestamp')
    setDefaultInvalidInstituteIdCookie()
    window.location.replace('/LoginSignup')
    return null
  }
  
  // Check cookie first (synchronous check) before checking user state
  // This prevents race conditions on page refresh
  if (!hasValidInstituteIdCookie()) {
    Cookies.remove('institute_id')
    Cookies.remove('institute_name')
    sessionStorage.removeItem('institute_confirmed')
    sessionStorage.removeItem('institute_confirmed_timestamp')
    setDefaultInvalidInstituteIdCookie()
    // Use window.location for immediate redirect
    window.location.replace('/LoginSignup')
    return null // Don't render anything while redirecting
  }
  
  return <Dashboard />
}

function App() {
  const location = useLocation()
  const isAuthPage =
    location.pathname === '/LoginSignup' || location.pathname === '/SignUp'
  const isParentRegPage = location.pathname === '/Parent/Registration'

  const { user } = useAuth()
  const canManageHolidays =
    String(user?.user_type || '').toLowerCase() === 'admin' ||
    (Array.isArray(user?.roles) &&
      user.roles.map((role) => String(role).toLowerCase()).includes('admin'))
  const isTeacherPortalUser =
    (String(user?.user_type || '').toLowerCase() === 'teacher' ||
      (Array.isArray(user?.roles) &&
        user.roles.map((role) => String(role).toLowerCase()).includes('teacher'))) &&
    !canManageHolidays
  const canViewFeeUpdateLogs = (() => {
    const userType = String(user?.user_type || '').toLowerCase()
    const roles = (user?.roles || []).map((role) => String(role).toLowerCase())
    const allowed = ['admin', 'accountant', 'superadmin']
    return allowed.includes(userType) || roles.some((role) => allowed.includes(role))
  })()

  const [isDesktopAuthLayout, setIsDesktopAuthLayout] = useState(
    () => typeof window !== 'undefined' && window.innerWidth >= 992,
  )

  useEffect(() => {
    const onResize = () => setIsDesktopAuthLayout(window.innerWidth >= 992)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  if (!user && !isAuthPage && !isParentRegPage) {
    return <Navigate to="/LoginSignup" replace />
  }

  // Non-admin portal requires a valid institute; InstituteContext logs out — block shell to avoid 401 API spam
  const requiresValidInstitute =
    user &&
    user.user_type !== 'admin' &&
    !isAuthPage &&
    !isParentRegPage
  if (requiresValidInstitute && !hasValidInstituteIdCookie()) {
    return null
  }

  const showSidenavbar =
    !isAuthPage && user && (user.user_type === 'admin' || hasValidInstituteIdCookie())

  const lockAuthViewport = isAuthPage && isDesktopAuthLayout

  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            // zIndex: 9999,
            borderRadius: '8px',
            color: '#fff',
            padding: '10px',
            fontSize: '16px',
          },
          success: {
            style: { background: '#4caf50', color: '#fff' },
          },
          error: {
            style: { background: '#d32f2f', color: '#fff' },
          },
        }}
      />

      <SidebarProvider>
        <div
          className="App"
          style={{
            display: 'flex',
            ...(lockAuthViewport
              ? { height: '100dvh', maxHeight: '100dvh', overflow: 'hidden' }
              : {}),
          }}
        >
          {showSidenavbar && <Sidenavbar />}
          <div
            className="app-main-content"
            style={{
              flex: 1,
              minWidth: 0,
              maxWidth: '100%',
              padding: lockAuthViewport ? 0 : '12px 0px',
              position: 'relative',
              zIndex: 1,
              ...(lockAuthViewport
                ? {
                    height: '100dvh',
                    maxHeight: '100dvh',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                  }
                : {}),
            }}
          >
          <SubscriptionPlanGuard>
          <Routes>

            <Route path="/" element={<Navigate to="/LoginSignup" />} />
            <Route path="/LoginSignup" element={<LoginSignup />} />
            <Route path="/SignUp" element={<RegistrationWizard />} />
            {/* <Route path="/Dashboard" element={<Navigate to="/LoginSignup" />} /> */}
            <Route path="/students" element={<AddStudent />} />
            <Route path="/student/add" element={<AddNewStudent />} />
            <Route path="/TeacherStudent" element={<TeacherStudent/>} />
            {/* <Route path="/StudentList" element={<StudentList />} /> */}
            <Route path="/AddCourse" element={<AddCourse />} />
            <Route path="/AddClass" element={<AddClass />} />
            <Route path="/ClassList" element={<ClassList />} />
            <Route
              path="/TakeAttendance/:student_id?/:course_id?/:class_id?"
              element={<TakeAttendance />}
            />
            <Route
              path="/TakeTeacherAttendance"
              element={<TakeTeacherAttendance />}
            />
            <Route
              path="/ViewTeacherAttendance"
              element={<ViewTeacherAttendance />}
            />
            <Route path="/MyAttendance" element={<MyTeacherAttendance />} />
            <Route
              path="/TakeLeave"
              element={
                isTeacherPortalUser ? (
                  <TakeLeave />
                ) : (
                  <Navigate to="/AssignClass" replace />
                )
              }
            />
            <Route
              path="/ViewLeave"
              element={
                canManageHolidays ? (
                  <ViewLeave />
                ) : (
                  <Navigate to="/Dashboard" replace />
                )
              }
            />
            <Route
              path="/student/view-attendance/:student_id/:course_id/:class_id"
              element={<ViewAttendance />}
            />
            <Route path="/ViewAttendance" element={<ViewAttendance />} />
            <Route path="/Practicenavbar" element={<Practicenavbar />} />
            <Route path="/student/profile/:id/homework" element={<StudentHomework />} />
            <Route path="/student/profile/:id" element={<StudentProfile />} />
            <Route path="/student/:studentId/admit-card/:examId" element={<AdmitCard />} />
            <Route path="/student/:studentId/admit-card" element={<AdmitCard />} />
            <Route
              path="/student/:studentId/certificates/:certificateId"
              element={<StudentCertificateView />}
            />
            <Route
              path="/student/:studentId/certificates"
              element={<StudentCertificates />}
            />
            <Route
              path="/student/:studentId/marksheets/:examId"
              element={<StudentMarksheetView />}
            />
            <Route
              path="/student/:studentId/marksheets"
              element={<StudentMarksheets />}
            />
            <Route
              path="/student/:studentId/transfer-certificate/:tcId"
              element={<StudentTransferCertificateView />}
            />
            <Route
              path="/student/:studentId/transfer-certificate"
              element={<StudentTransferCertificate />}
            />
            {/* Legacy admit-card URLs → /student/:studentId/admit-card */}
            <Route path="/student/admit-card/:studentId/:examId" element={<LegacyAdmitCardRedirect />} />
            <Route path="/student/admit-card/:studentId" element={<LegacyAdmitCardRedirect />} />
            <Route path="/admit-card/:studentId/:examId" element={<LegacyAdmitCardRedirect />} />
            <Route path="/admit-card/:studentId" element={<LegacyAdmitCardRedirect />} />
            <Route path="/student/discharged/profile/:id" element={<DischargedStudentsProfile />} />
            <Route path="/student/enrolled-courses/:id" element={<EnrolledCourses />} />
            <Route path="/students/passed-out" element={<PassedOutStudent />} />
            <Route
              path="/TakeFees/:student_id?/:course_id?"
              element={<TakeFees />}
            />
            <Route path="/EnquiryForm" element={<EnquiryForm />} />
            <Route path="/AddNewEnquiry" element={<AddNewEnquiry />} />
            <Route path="/CourseFees" element={<CourseFees />} />
            <Route path="/student/id-card/:id" element={<IDcard />} />
            <Route path="/StudentPromotion" element={<StudentPromotion />} />
            <Route
              path="/ExamMarksheet/:student_id?/:course_id?/:class_id?"
              element={<ExamMarksheetView />}
            />
            <Route path="/TeacherList" element={<TeacherList />} />
            <Route path="/ManageHolidays" element={<ManageHolidays />} />
            <Route
              path="/CreateHoliday"
              element={canManageHolidays ? <CreateHoliday /> : <Navigate to="/ManageHolidays" replace />}
            />
            <Route
              path="/EditHoliday/:id"
              element={canManageHolidays ? <CreateHoliday /> : <Navigate to="/ManageHolidays" replace />}
            />
            <Route path="/Templates" element={<ManageTemplates />} />
            <Route path="/EditTemplate/:id" element={<EditTemplate />} />
            <Route path="/updates" element={<Notification />} />

            <Route path="/AddNewTeacher" element={<AddNewTeacher />} />
            <Route
              path="/UpdateTeacherProfile/:teacher_id?"
              element={<EditTeacherModal show={true} />}
            />
            <Route path="/AddGuardian/:student_id?/:course_id?/:class_id?" element={<GuardianTable />} />
            <Route path="/Guardian/ChangePassword/:id" element={<GuardianChangePwd />} />
            <Route path="/Guardian/:guardianId/Students" element={<ViewAssignedStudents />} />
            <Route path="/Guardian/:guardianId/AssignStudents" element={<AssignStudentsToGuardian />} />
            <Route path="/FeeStructure" element={<FeeStructure />} />
            <Route
              path="/ApplyFees/:course_id?/:student_id?"
              element={<ApplyFees />}
            />
            <Route path="/Dashboard" element={<ProtectedDashboard />} />
            <Route path="/" element={<ProtectedDashboard />} />
            <Route path="/AddInstitute" element={<AddInstitute />} />
            <Route path="/AddInstitute/New" element={<AddNewInstitute />} />
            <Route path="/ManageInstitute" element={<ManageInstitute />} />
            <Route path="/AddSubject" element={<AddSubject />} />
            <Route path="/ExamSheet" element={<ExamSheet />} />
            <Route path="/ExamSheet/Add" element={<AddExamForCourse />} />
            <Route
              path="/ExamSheet/Admitcard/:student_id/:exam_id"
              element={<ExamSheetAdmitcard />}
            />
            <Route path="/ExamSheet/Admitcard/:student_id" element={<ExamSheetAdmitcard />} />
            <Route path="/ExamSheet/Admitcard" element={<ExamSheetAdmitcard />} />
            <Route path="/ExamSheet/BulkAdmitcard" element={<ExamSheetBulkAdmitcard />} />
            <Route path="/ExamSheet/schedule/:examid" element={<ExamSubjectSchedule />} />
            <Route path="/AddUser" element={<AddUser />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/user-id-card" element={<UserIdCard />} />
            <Route path="/user-id-card/:id" element={<UserIdCard />} />
            <Route path="/Assign/UserRole/:id" element={<AssignUserRole />} />
            <Route
              path="/AddExamResult/:student_id?/:course_id?/:class_id?"
              element={<AddExamResult />}
            />
            <Route path="/AssignClass" element={<AssignClass />} />
            <Route
              path="/ManageStudentFees/:student_id?/:course_id?/:class_id?"
              element={<ManageStudentFees />}
            />
            <Route path="/FeeChangeLogs/:fee_id" element={<FeeChangeLogs />} />
            <Route
              path="/FeeUpdateLogs"
              element={
                canViewFeeUpdateLogs ? (
                  <FeeUpdateLogs />
                ) : (
                  <Navigate to="/Dashboard" replace />
                )
              }
            />
            <Route path="/student/fees/:student_id?" element={<StudentFees />} />
            <Route path="/Certificate/:student_id?/:course_id?/:class_id?" element={<CertificateView />} />
            <Route
              path="/certificate/template1"
              element={(
                <CertificateTemplate1
                  studentName="Student Name"
                  courseName="Course Name"
                  date={new Date().toLocaleDateString()}
                  instituteName="Institute Name"
                  certificateTitle="Certificate of Achievement"
                  authorityName="Authority Signature"
                />
              )}
            />
            <Route
              path="/certificate/template2"
              element={(
                <CertificateTemplate2
                  studentName="Student Name"
                  courseName="Course Name"
                  date={new Date().toLocaleDateString()}
                  instituteName="Institute Name"
                  certificateTitle="Certificate of Completion"
                  authorityName="Authority Signature"
                />
              )}
            />
            <Route
              path="/certificate/template3"
              element={(
                <CertificateTemplate3
                  studentName="Student Name"
                  courseName="Course Name"
                  date={new Date().toLocaleDateString()}
                  instituteName="Institute Name"
                  certificateTitle="Certificate of Completion"
                  authorityName="Authority Signature"
                  certificateId="CERT-2026-0003"
                />
              )}
            />
            <Route
              path="/certificate/template4"
              element={(
                <CertificateTemplate4
                  studentName="Student Name"
                  courseName="Course Name"
                  date={new Date().toLocaleDateString()}
                  instituteName="Institute Name"
                  certificateTitle="Certificate of Completion"
                  authorityName="Authority Signature"
                  certificateId="CERT-2026-0004"
                />
              )}
            />
            <Route
              path="/certificate/template5"
              element={(
                <CertificateTemplate5
                  studentName="Alexandra Chen"
                  courseName="Advanced Data Analytics & Visualization"
                  date={new Date().toLocaleDateString()}
                  instituteName="Global Institute of Professional Studies"
                  certificateTitle="Certificate of Completion"
                  certificateId="CERT-2026-001"
                  instructorName="Dr. James Mitchell"
                />
              )}
            />
            <Route
              path="/certificate/template6"
              element={(
                <CertificateTemplate6
                  studentName="Alexandra Chen"
                  courseName="Leadership & Organizational Excellence"
                  date={new Date().toLocaleDateString()}
                  instituteName="Global Institute of Professional Studies"
                  certificateTitle="Certificate of Achievement"
                  certificateId="CERT-2026-002"
                  instructorName="Prof. Elena Vasquez"
                />
              )}
            />
            <Route
              path="/certificate/template7"
              element={(
                <CertificateTemplate7
                  studentName="Jordan Ellis"
                  courseName="Digital Learning & Instructional Design"
                  date={new Date().toLocaleDateString()}
                  instituteName="Riverside Academy of Excellence"
                  certificateTitle="Certificate of Completion"
                  certificateId="CERT-2026-007"
                  watermarkUrl="/logo.svg"
                />
              )}
            />
            <Route
              path="/certificate/template8"
              element={(
                <CertificateTemplate8
                  studentName="Jordan Ellis"
                  courseName="Leadership & Public Administration"
                  date={new Date().toLocaleDateString()}
                  instituteName="Riverside Academy of Excellence"
                  certificateTitle="Certificate of Achievement"
                  certificateId="CERT-2026-008"
                  watermarkUrl="/logo.svg"
                />
              )}
            />
            <Route path="/GenerateTC" element={<GenerateTC />} />
            <Route path="/TemplateAssignment" element={<TemplateAssignment />} />
            <Route path="/TransferCertificate" element={<TransferCertificateList />} />
            <Route path="/TemplateBasedCertificate" element={<TemplateBasedCertificate />} />
            {/* <Route path="/AssignTemplateCertificate" element={<AssignTemplateCertificate />} /> */}
            <Route path="/TransferCertificate/:id" element={<TransferCertificateView />} />
            <Route path="/Transfer/Certificate" element={<StudentTC />} />            
            <Route path="/owner-viv-ins-of-clg" element={<VivekanandCertificate />} />
            <Route
              path="/FeeRecipt/:studentId/:feeIds"
              element={<FeeRecipt />}
            />
            <Route path="/TeacherProfile/:id?" element={<TeacherProfile />} />
            <Route path="/TeacherIdCard/:id?" element={<TeacherIdcard />} />
            <Route path="ChangePassword" element={<ChangePassword />} />
            <Route path="/FeeCollection" element={<FeeCollection />} />
            <Route path="/PendingFee" element={<PendingFee />} />
            <Route path="/Marketer" element={<Marketer />} />
            <Route path="Settings" element={<Setting />} />
            <Route
              path="/student/update-profile/:student_id"
              element={<UpdateStudentProfile />}
            />
            <Route
              path="/UpdateStudentEnquiry/:student_id"
              element={<UpdateStudentEnquiry />}
            />
            <Route path="/student/discharged" element={<DischargedStudent />} />
            <Route path="/LeftTeachers" element={<LeftTeachers />} />
            <Route path="/student/dischargedFees/:student_id?" element={<DischargedStudentFees />} />
            <Route path="/student/discharged/attendance/:student_id/:course_id/:class_id" element={<DischargedStdAttendance />} />
            {/* Parent's routes */}
            <Route path="/parent/dashboard" element={<ParentDashboard />} />
            <Route path="/parent/student/list" element={<ParentStudentList />} />
            <Route path="/parent/student/profile/:id/homework" element={<StudentHomework />} />
            <Route path="/parent/student/profile/:id?" element={<ParentStudentProfile />} />
            <Route path="/parent/student/fees/:student_id?/:course_id?/:class_id?" element={<ParentStudentFees />} />
            <Route path="/parent/student/attendance/:student_id/:course_id/:class_id?" element={<ParentViewAttendance />} />
            <Route path="/parent/homework" element={<ParentHomework />} />
            <Route path="/parent/homework" element={<ParentHomework />} />
            <Route path="/parent/holidays" element={<ParentHolidays />} />
            <Route path="/parent/holidays" element={<ParentHolidays />} />
            <Route path="/Parent/Registration" element={<ParentRegistration />} />
            <Route path="/parent/raise-query" element={<RaiseQuery />} />
            {/* Notification / Announcement */}
            <Route path="/Notifications" element={<CreateNotification />} />
            <Route path="/Announcements" element={<CreateAnnouncement />} />
            <Route path="/announcements" element={<CreateAnnouncement />} />
            <Route path="/CreateNotification" element={<NotificationForm />} />
            <Route path="/CreateAnnouncement" element={<AnnouncementForm />} />
            <Route path="/announcement/create" element={<AnnouncementForm />} />
            <Route path="/announcement/edit/:id" element={<AnnouncementForm />} />
            <Route path="/announcement/view/:id" element={<ViewAnnouncement />} />
            <Route path="/TopAnnouncements" element={<TopAnnouncementsEntry />} />
            <Route path="/parent/top-announcements" element={<ParentTopAnnouncements />} />
            <Route path="/homework" element={<Homework />} />
            <Route path="/Homework" element={<Homework />} />
            <Route path="/homework/create" element={<HomeworkForm />} />
            <Route path="/Homework/create" element={<HomeworkForm />} />
            <Route path="/homework/edit/:id" element={<HomeworkForm />} />
            <Route path="/Homework/edit/:id" element={<HomeworkForm />} />
            {/* Transport */}
            <Route path="/Transport" element={<ManageBus />} />
            <Route path="/parent/bus/allocation" element={<BusAllocation />} />
            <Route path="/AttendantPortal" element={<AttendantPortal />} />
            <Route path="/TrackVehicle" element={<TrackVehicle />} />
            <Route path="/vehicle/track/:vehicle_id" element={<VehicleTrackPage />} />
            <Route path="/CreateBus" element={<CreateBus />} />
            <Route path="/AssignBusToStudent" element={<AssignBustoStudent />} />
            <Route path="/ViewBusAssignedStd" element={<ViewBusAssignedStd />} />
            <Route path='/ViewBusAssignedStudent/:busId' element={<ViewBusAssignedStudent/>}/>
            <Route path='/AssigningBustoStd/:busId' element={<AssigningBustoStd/>}/>
            {/* <Route path='/Viewadmitcard' element={<ViewAdmitCard/>}/> */}
            <Route
                  path="/ViewExam/:studentId"
                  element={<ViewExam />}
            />

            <Route path="/parent/my-queries" element={<MyQueries />} />

              <Route path="/admin-parent-queries" element={<AdminParentQueryList />} />
              <Route path="/admin/subscription/plans" element={<AdminSubscriptionPlans />} />
              <Route path="/admin/subscription" element={<AdminSubscription />} />
            
            </Routes>
          </SubscriptionPlanGuard>

          </div>
        </div>
      </SidebarProvider>
    </>
  )
}

export default App

